import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function FeaturedTreatments() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-dark text-white relative" data-id="element-77" data-mp="2affr9n2m7cdp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78" data-mp="2eeyameesffef">
        <div className="text-center mb-10 md:mb-16" data-id="element-79" data-mp="325apk98gacei">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-80" data-mp="326lr02efb82g">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-gold-light mb-4 md:mb-6" data-id="element-81" data-mp="2y5joncp7mfw9">
              {t('featured.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-82" data-mp="1mplf77q4drui"></div>
          </motion.div>
        </div>

        {/* Hero Treatment: Acne */}
        <motion.div className="bg-white/5 border border-brand-gold/30 p-8 md:p-12 rounded-sm mb-12 relative overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-83" data-mp="mlys34o4gmnq">
          <div className="btn-gold-animated absolute top-0 right-0 overflow-hidden text-white px-6 py-2 rounded-bl-lg font-bold text-sm tracking-wider flex items-center gap-2" data-id="element-84" data-mp="15k1ldvnpd5rc">
            <span aria-hidden="true" className="sheen pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 skew-x-[-20deg] bg-white/25 blur-md" data-id="element-85" data-mp="1facppjbatgyr" />
            <Trophy className="relative w-4 h-4" data-id="element-86" data-mp="1p9c29cz6pwr1" />
            <span className="relative" data-id="element-87" data-mp="1pan5nbopx2hm">{t('featured.badge')}</span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-88" data-mp="1wdbg46jurg28">
            <div data-id="element-89" data-mp="21ak3qmnrscav">
              <h3 className="text-3xl font-serif text-brand-gold-light mb-4 mt-4 lg:mt-0" data-id="element-90" data-mp="21c4x48yclp75">
                {t('featured.hero_title')}
              </h3>
              <p className="text-gray-300 mb-6 text-lg" data-id="element-91" data-mp="2b0wks4wdlnc9">
                {t('featured.hero_desc')}
              </p>

              <div className="mb-6" data-id="element-92" data-mp="2f2qflwjw3x4i">
                <h4 className="text-white font-semibold mb-2" data-id="element-93" data-mp="2f1oxx98dccdt">
                  {t('featured.who_title')}
                </h4>
                <p className="text-gray-400 text-sm" data-id="element-94" data-mp="2k3nykbcq4v72">
                  {t('featured.who_desc')}
                </p>
              </div>

              <div className="flex flex-wrap gap-4 text-sm text-gray-300" data-id="element-95" data-mp="2u0ahgulhpc6g">
                <div className="bg-black/30 px-4 py-2 rounded-sm border border-white/10" data-id="element-96" data-mp="ummwtbw1q0ly">
                  <span className="text-brand-gold font-semibold" data-id="element-97" data-mp="uozpaizfjtd9">
                    {t('featured.duration_label')}
                  </span>{' '}
                  {t('featured.duration_val')}
                </div>
                <div className="bg-black/30 px-4 py-2 rounded-sm border border-white/10" data-id="element-98" data-mp="385j7qkjkv484">
                  <span className="text-brand-gold font-semibold" data-id="element-99" data-mp="343pa6l4oigc6">
                    {t('featured.freq_label')}
                  </span>{' '}
                  {t('featured.freq_val')}
                </div>
              </div>

              {/* Before / After Visual */}
              <motion.figure className="mt-8 group relative overflow-hidden rounded-sm border border-brand-gold/30 bg-black/40" initial={{
              opacity: 0,
              y: 30,
              scale: 0.97
            }} whileInView={{
              opacity: 1,
              y: 0,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.7,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-100" data-mp="3vu2e2uj2h6xk">
                <img src="https://cdn.magicpatterns.com/uploads/tmPPunK7nK7BhbpR7tn2JN/TRATAMIENTO_PARA_EL_ACNE.png" alt="Resultado real de tratamiento para el acné: antes y después" loading="lazy" className="w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" data-id="element-101" data-mp="2y7glva63034" />

                {/* Center divider */}
                <div className="pointer-events-none absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-brand-gold/70" data-id="element-102" data-mp="lwa3o4j5mmya"></div>

                {/* Antes / Después labels */}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-between p-3 text-[10px] md:text-xs font-semibold uppercase tracking-widest text-white" data-id="element-103" data-mp="cv2h2jq03ak1">
                  <span className="bg-black/60 border border-white/10 px-3 py-1 rounded-sm" data-id="element-104" data-mp="2xmvwp5tb3f8s">
                    Antes
                  </span>
                  <span className="bg-brand-gold/90 px-3 py-1 rounded-sm" data-id="element-105" data-mp="2q10ezaq34x0g">
                    Después
                  </span>
                </div>

                {/* Animated gold shine sweep */}
                <motion.div className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-white/25 to-transparent" initial={{
                x: '-50%',
                opacity: 0
              }} whileInView={{
                x: '450%',
                opacity: 1
              }} viewport={{
                once: true,
                amount: 0.3
              }} transition={{
                duration: 1.6,
                delay: 0.5,
                ease: 'easeInOut'
              }} data-id="element-106" data-mp="2z2qihex8rmel" />
              </motion.figure>
            </div>

            <div data-id="element-107" data-mp="3irsr45a4zihc">
              <h4 className="text-white font-semibold mb-4 text-xl" data-id="element-108" data-mp="3isaxvvufdf3i">
                {t('featured.achieve_title')}
              </h4>
              <ul className="space-y-4" data-id="element-109" data-mp="3norn6tdd1zi6">
                {[t('featured.achieve_1'), t('featured.achieve_2'), t('featured.achieve_3'), t('featured.achieve_4'), t('featured.achieve_5')].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-110" data-mp="2zv00kgscsvqp" data-mpi={idx}>
                    <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-111" data-mp="34s9ykktt6fq5" />
                    <span className="text-gray-300" data-id="element-112" data-mp="39q1qvfyd83uv">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Other Featured */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-113" data-mp="p02jb7l8fwss">
          {[{
          title: t('featured.t1_title'),
          desc: t('featured.t1_desc')
        }, {
          title: t('featured.t2_title'),
          desc: t('featured.t2_desc')
        }, {
          title: t('featured.t3_title'),
          desc: t('featured.t3_desc')
        }, {
          title: t('featured.t4_title'),
          desc: t('featured.t4_desc')
        }].map((item, idx) => <motion.div key={idx} className="bg-white/5 border border-white/10 p-6 rounded-sm hover:border-brand-gold/50 transition-colors" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3 + idx * 0.1
        }} data-id="element-114" data-mp="1uujqdpgup2gn" data-mpi={idx}>
              <h4 className="text-xl font-serif text-brand-gold-light mb-3" data-id="element-115" data-mp="2k2w94q6fp9vk">
                {item.title}
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-116" data-mp="2p0pifs31ak02">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}